import React from 'react';
import { Box, Typography, Chip } from '@mui/material';

// Multi-select filter row of toggleable MUI Chips — `selected` is a Set,
// clicking a chip toggles its membership. `options` is the full canonical
// vocabulary (not just values currently present in the data), so a style/
// level/size nobody's used yet is still selectable.
export default function ChipFilterRow({ label, options, selected, onToggle }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75, flexWrap: 'wrap', mb: 1 }}>
      <Typography variant="caption" color="text.secondary" sx={{ width: 50, flexShrink: 0 }}>{label}</Typography>
      {options.map((opt) => {
        const active = selected.has(opt);
        return (
          <Chip
            key={opt}
            label={opt}
            size="small"
            onClick={() => onToggle(opt)}
            color={active ? 'primary' : 'default'}
            variant={active ? 'filled' : 'outlined'}
          />
        );
      })}
    </Box>
  );
}
